/* EditionSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import EditorInfoPanel from '@atlaskit/icon/glyph/editor/panel';
import Select from '@atlaskit/select';
import { ExternalLink, RichTooltip } from '@atlassian/mpac-ui';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _10 = "._1bsb1vq3{width:13.188rem}";
const _9 = "._d0altlke:hover{cursor:pointer}";
const _8 = "._irr3108i:hover{background-color:var(--ds-surface-hovered,#f1f2f4)}";
const _7 = "._8vu41l7b:hover{border-radius:3px}";
const _6 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _5 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _ = "._p12fd60k{max-width:18.75rem}";
const plansTextContainer = null;
const tooltipDialogContent = null;
const tooltipDialogText = null;
const selectBox = null;
export const EditionSelector = props => {
  const tooltipContent = /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_p12fd60k"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_otyr1b66"]),
          children: "This app offers two different plans - Standard and Advanced. You can start a free trial of either plan, and change your plan anytime during or after the trial."
        })]
      }), /*#__PURE__*/_jsx(ExternalLink, {
        href: props.links.appPricingDetails.expand({
          appKey: props.installableApp.marketplaceAppDetails.key
        }),
        children: "Explore pricing plans"
      })]
    })]
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(RichTooltip, {
      content: tooltipContent,
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6, _7, _8, _9]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1e0c1txw _4cvr1h6o _otyru2gc _1bsb1ns9 _8vu41l7b _irr3108i _d0altlke"]),
          children: ["Plan", /*#__PURE__*/_jsx(EditorInfoPanel, {
            label: "Editor Info Icon"
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_10]
      }), /*#__PURE__*/_jsx(Select, {
        isSearchable: false,
        options: props.editions.map(edition => ({
          label: capitalize(edition.type),
          value: edition.type
        })),
        value: props.selectedEditionType,
        onChange: value => value && props.setSelectedEditionType(value),
        className: ax(["_1bsb1vq3"])
      })]
    })]
  });
};